<template>
<div class="chapter">
<div class="inner_page">
<h2 class="Title" id="_idParaDest-1">Contents</h2>
<p class="firstleft"><a href="#/Text/gettingmost#_idTextAnchor000">Getting the Most Out of <i>Apostles’ Creed</i></a></p>
<blockquote>
<p class="first"><span href="#/Text/ch1#_idTextAnchor001" title="Link target outside of Sample"><b>1 I Believe</b>—Genesis 12:1-8; 15:1-6</span></p>
<p class="firstleft"><span href="#/Text/ch2#_idTextAnchor002" title="Link target outside of Sample"><b>2 God the Father</b>—Isaiah 40:21-31</span></p>
<p class="firstleft"><span href="#/Text/ch3#_idTextAnchor003" title="Link target outside of Sample"><b>3 God the Son: His Identity and Birth</b>—Philippians 2:5-11</span></p>
<p class="firstleft"><span href="#/Text/ch4#_idTextAnchor004" title="Link target outside of Sample"><b>4 God the Son: His Death and Resurrection</b>—1 Corinthians 15:1-28</span></p>
<p class="firstleft"><span href="#/Text/ch5#_idTextAnchor005" title="Link target outside of Sample"><b>5 God the Son: His Present Activity and Future Role; God the Holy Spirit</b>—Colossians 1:15-20; 1 Corinthians 12:1-11</span></p>
<p class="firstleft"><span href="#/Text/ch6#_idTextAnchor006" title="Link target outside of Sample"><b>6 The Church, ­Forgiveness and Eternal Life</b>—Ephesians 4:1-13</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/leadersnotes#_idTextAnchor008" title="Link target outside of Sample">Leader’s Notes</span></p>
<p class="firstleft"><span href="#/Text/author#_idTextAnchor009" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/alsofrom" title="Link target outside of Sample">Also from Alister McGrath</span></p>
<p class="firstleft"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?aef93124